import React from "react";
import styles from "./agentMetricTag.module.css";

interface AgentMetricTagProps {
    label: string;
    value: number;
    color: string;
}

export const AgentMetricTag = (props: AgentMetricTagProps) => {
    const { label, value, color } = props;

    return (
        <div className={styles.agentMetricTagCtn} style={{ boxShadow: `0px 0px 1.5px 0px ${color}` }}>
            <span className={styles.agentMetricTagText} style={{ color }}>
                {label}: {value}
            </span>
        </div>
    );
};
